import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { newId } from './settings';

export interface ListItem {
  id: string;
  text: string;
  done: boolean;
  category: string;
  createdAt: number;
}

export interface TaskList {
  id: string;
  name: string;
  kind: 'todo' | 'shopping';
  items: ListItem[];
}

export const SHOPPING_CATEGORIES = ['Fruit & veg', 'Dairy', 'Bakery', 'Meat & fish', 'Household', 'Other'];
export const TODO_CATEGORIES = ['Home', 'Work', 'Family', 'Errands', 'Other'];

interface ListsStore {
  lists: TaskList[];
  addItem: (listId: string, text: string, category: string) => void;
  toggleItem: (listId: string, itemId: string) => void;
  removeItem: (listId: string, itemId: string) => void;
  clearDone: (listId: string) => void;
  replaceAll: (lists: TaskList[]) => void;
}

const defaultLists: TaskList[] = [
  { id: 'todo', name: 'To-do', kind: 'todo', items: [] },
  { id: 'shopping', name: 'Shopping', kind: 'shopping', items: [] },
];

const mapList = (lists: TaskList[], id: string, fn: (l: TaskList) => TaskList) =>
  lists.map((l) => (l.id === id ? fn(l) : l));

export const useLists = create<ListsStore>()(
  persist(
    (set) => ({
      lists: defaultLists,
      addItem: (listId, text, category) =>
        set((s) => ({
          lists: mapList(s.lists, listId, (l) => ({
            ...l,
            items: [...l.items, { id: newId(), text: text.trim(), done: false, category, createdAt: Date.now() }],
          })),
        })),
      toggleItem: (listId, itemId) =>
        set((s) => ({
          lists: mapList(s.lists, listId, (l) => ({
            ...l,
            items: l.items.map((i) => (i.id === itemId ? { ...i, done: !i.done } : i)),
          })),
        })),
      removeItem: (listId, itemId) =>
        set((s) => ({ lists: mapList(s.lists, listId, (l) => ({ ...l, items: l.items.filter((i) => i.id !== itemId) })) })),
      clearDone: (listId) =>
        set((s) => ({ lists: mapList(s.lists, listId, (l) => ({ ...l, items: l.items.filter((i) => !i.done) })) })),
      replaceAll: (lists) => set({ lists: lists.length ? lists : defaultLists }),
    }),
    { name: 'kcl-canvas-lists', version: 1, partialize: (s) => ({ lists: s.lists }) },
  ),
);
